<!-- About Hero -->
<section class="relative bg-slate-50/50">
  <!-- Background gradient -->
  <img class="absolute inset-0 object-cover object-left w-full h-full lg:w-2/3" src="/assets/img/about-hero-bg.svg" />

  <!-- Content -->
  <div class="relative max-w-screen-xl px-5 py-16 mx-auto sm:py-24 lg:py-32 sm:px-6 lg:px-8">
    <div class="max-w-3xl px-4 mx-auto sm:px-6 lg:mx-0 lg:w-2/3 lg:max-w-none lg:px-8 lg:pr-16">
      <h1 class="text-5xl font-semibold font-display text-slate-900 sm:text-6xl">
        <!-- Highlighted text -->
        <span class="relative whitespace-nowrap">
          <svg
            class="absolute top-2/3 left-0 h-[0.6em] w-full fill-sky-200/75"
            fill="currentColor"
            height="22"
            viewBox="0 0 249 22"
            width="249"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M247.564 18.5807C241.772 13.3568 232.473 12.7526 225.225 11.4427C217.124 9.97395 208.996 8.57031 200.846 7.46093C186.542 5.51302 172.169 4.08854 157.79 3.01562C126.033 0.645827 94.0929 0.0338481 62.3387 2.36979C42.1785 3.85416 22.008 5.90885 2.32917 10.8463C-0.0155171 11.4349 0.207047 14.6719 2.6889 14.7083C22.0261 14.9896 41.3866 12.6406 60.7109 11.8568C79.9471 11.0807 99.2274 10.6719 118.484 10.9557C142.604 11.3125 166.719 12.8333 190.722 15.5156C199.956 16.5469 209.195 17.6016 218.411 18.8255C227.864 20.0807 237.259 22 246.767 20.7422C247.709 20.6198 248.426 19.3568 247.564 18.5807Z" />
          </svg>
          <span class="relative">{{ environmentConfig.config.name }}</span>
        </span>
        {{ 'PAGE.ABOUT.HERO.TITLE' | translate }}
      </h1>
      <p class="mt-8 text-lg leading-8 text-slate-700">
        {{ 'PAGE.ABOUT.HERO.INTRO.1' | translate }}
      </p>
      <p class="mt-6 text-lg leading-8 text-slate-700">
        {{ 'PAGE.ABOUT.HERO.INTRO.2' | translate }}
      </p>
    </div>
  </div>

  <!-- Image -->
  <div class="relative h-96 w-full md:h-[600px] lg:absolute lg:inset-y-0 lg:right-0 lg:h-full lg:w-1/3">
    <img class="absolute inset-0 object-cover object-top w-full h-full" src="/assets/img/about-hero.jpg" />
    <svg
      class="absolute left-0 w-auto h-8 -translate-x-1/2 bottom-16 mt-14 sm:mt-20 sm:h-10"
      fill="none"
      height="40"
      viewBox="0 0 229 40"
      width="229"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_204_150)">
        <path
          d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
          stroke="#0369A1"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2" />
        <path
          d="M1 19L29.4 39L57.7 19L86.1 39L114.5 19L142.8 39L171.2 19L199.6 39L228 19"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-opacity="0.2"
          stroke-width="2" />
        <path
          d="M1 1L29.4 21L57.7 1L86.1 21L114.5 1L142.8 21L171.2 1L199.6 21L228 1"
          stroke="#BAE6FD"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2" />
      </g>
      <defs>
        <clipPath id="clip0_204_150">
          <rect fill="white" height="40" width="229" />
        </clipPath>
      </defs>
    </svg>
  </div>
</section>

<!-- Work Experience -->
<section class="relative py-16 bg-white overflow-x-clip sm:py-24 lg:py-32">
  <!-- Container -->
  <div class="relative max-w-screen-xl px-5 mx-auto sm:px-6 lg:px-8">
    <div class="grid max-w-2xl grid-cols-1 mx-auto gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
      <!-- Section header with button -->
      <div>
        <h2 class="text-4xl font-semibold font-display text-slate-900 sm:text-5xl">
          {{ 'PAGE.ABOUT.HISTORY.TITLE.1' | translate }}

          <!-- Highlighted text -->
          <span class="relative whitespace-nowrap">
            <svg
              class="absolute top-2/3 left-0 h-[0.6em] w-full fill-sky-200/75"
              fill="currentColor"
              height="24"
              viewBox="0 0 167 24"
              width="167"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_257_225)">
                <path
                  d="M166.409 20.2699C162.515 14.571 156.265 13.9119 151.392 12.4829C145.948 10.8807 140.484 9.3494 135.006 8.13918C125.391 6.01418 115.729 4.4602 106.064 3.28974C84.7177 0.704517 63.2477 0.036903 41.9031 2.5852C28.3517 4.20452 14.7934 6.44599 1.5656 11.8324C-0.0104672 12.4744 0.139137 16.0057 1.8074 16.0454C14.8056 16.3522 27.8194 13.7897 40.8089 12.9346C53.7392 12.088 66.6991 11.642 79.6433 11.9517C95.8562 12.3409 112.066 14 128.2 16.9261C134.407 18.0511 140.617 19.2017 146.812 20.5369C153.167 21.9062 159.481 24 165.873 22.6278C166.506 22.4943 166.988 21.1164 166.409 20.2699Z" />
              </g>
              <defs>
                <clipPath id="clip0_257_225">
                  <rect fill="white" height="24" width="167" />
                </clipPath>
              </defs>
            </svg>

            <span class="relative text-sky-700">{{ 'PAGE.ABOUT.HISTORY.TITLE.2' | translate }}</span>
          </span>
        </h2>
        <p class="mt-6 text-lg leading-relaxed text-slate-700">
          {{ 'PAGE.ABOUT.HISTORY.INTRO' | translate }}
        </p>

        <!-- Download CV button -->
        <button
          class="mt-10 text-slate-900 shadow-sm shadow-sky-100/50 ring-1 ring-slate-100 hover:bg-slate-200/60 hover:shadow-sky-100/50 bg-slate-100/80 inline-flex items-center rounded-full gap-2.5 justify-center px-7 py-3 text-md font-semibold leading-none outline-offset-2 transition-all duration-200 ease-in-out active:transition-none">
          {{ 'PAGE.ABOUT.HISTORY.CTA' | translate }}
        </button>
      </div>

      <!-- Work list -->
      <ol
        class="col-span-2 grid grid-cols-1 gap-x-8 gap-y-10 text-base leading-7 text-gray-600 [counter-reset:section] sm:grid-cols-2 lg:gap-y-16">
        <!-- Work 1 -->
        <li
          class="relative [counter-increment:section] before:absolute before:right-0 before:-top-7 before:font-mono before:text-9xl before:font-black before:leading-none before:text-slate-50 before:content-[counter(section,decimal-leading-zero)]">
          <div>
            <p class="text-sm font-medium text-sky-700">{{ 'PAGE.ABOUT.HISTORY.LIST.1.DATE' | translate }}</p>
            <p class="mt-2 text-lg font-semibold font-display text-slate-900">
              {{ 'PAGE.ABOUT.HISTORY.LIST.1.TITLE' | translate }}
            </p>
          </div>
          <p class="mt-3 text-base leading-7 text-slate-700 relative z-1">
            {{ 'PAGE.ABOUT.HISTORY.LIST.1.INTRO' | translate }}
          </p>
        </li>

        <!-- Work 2 -->
        <li
          class="relative [counter-increment:section] before:absolute before:right-0 before:-top-7 before:font-mono before:text-9xl before:font-black before:leading-none before:text-slate-50 before:content-[counter(section,decimal-leading-zero)]">
          <div>
            <p class="text-sm font-medium text-sky-700">{{ 'PAGE.ABOUT.HISTORY.LIST.2.DATE' | translate }}</p>
            <p class="mt-2 text-lg font-semibold font-display text-slate-900">
              {{ 'PAGE.ABOUT.HISTORY.LIST.2.TITLE' | translate }}
            </p>
          </div>
          <p class="mt-3 text-base leading-7 text-slate-700 relative z-1">
            {{ 'PAGE.ABOUT.HISTORY.LIST.2.INTRO' | translate }}
          </p>
        </li>

        <!-- Work 3 -->
        <li
          class="relative [counter-increment:section] before:absolute before:right-0 before:-top-7 before:font-mono before:text-9xl before:font-black before:leading-none before:text-slate-50 before:content-[counter(section,decimal-leading-zero)]">
          <div>
            <p class="text-sm font-medium text-sky-700">{{ 'PAGE.ABOUT.HISTORY.LIST.3.DATE' | translate }}</p>
            <p class="mt-2 text-lg font-semibold font-display text-slate-900">
              {{ 'PAGE.ABOUT.HISTORY.LIST.3.TITLE' | translate }}
            </p>
          </div>
          <p class="mt-3 text-base leading-7 text-slate-700 relative z-1">
            {{ 'PAGE.ABOUT.HISTORY.LIST.3.INTRO' | translate }}
          </p>
        </li>

        <!-- Work 4 -->
        <li
          class="relative [counter-increment:section] before:absolute before:right-0 before:-top-7 before:font-mono before:text-9xl before:font-black before:leading-none before:text-slate-50 before:content-[counter(section,decimal-leading-zero)]">
          <div>
            <p class="text-sm font-medium text-sky-700">{{ 'PAGE.ABOUT.HISTORY.LIST.4.DATE' | translate }}</p>
            <p class="mt-2 text-lg font-semibold font-display text-slate-900">
              {{ 'PAGE.ABOUT.HISTORY.LIST.4.TITLE' | translate }}
            </p>
          </div>
          <p class="mt-3 text-base leading-7 text-slate-700 relative z-1">
            {{ 'PAGE.ABOUT.HISTORY.LIST.4.INTRO' | translate }}
          </p>
        </li>

        <!-- Work 5 -->
        <li
          class="relative [counter-increment:section] before:absolute before:right-0 before:-top-7 before:font-mono before:text-9xl before:font-black before:leading-none before:text-slate-50 before:content-[counter(section,decimal-leading-zero)]">
          <div>
            <p class="text-sm font-medium text-sky-700">{{ 'PAGE.ABOUT.HISTORY.LIST.5.DATE' | translate }}</p>
            <p class="mt-2 text-lg font-semibold font-display text-slate-900">
              {{ 'PAGE.ABOUT.HISTORY.LIST.5.TITLE' | translate }}
            </p>
          </div>
          <p class="mt-3 text-base leading-7 text-slate-700 relative z-1">
            {{ 'PAGE.ABOUT.HISTORY.LIST.5.INTRO' | translate }}
          </p>
        </li>

        <!-- Handwritten text with arrow -->
        <li
          class="relative mt-3 flex h-fit items-center font-writing text-2xl tracking-wide text-slate-600 sm:top-6 sm:left-14 sm:mt-0 sm:block sm:text-[27px] md:left-20">
          <span class="inline-block w-52 max-w-[240px] transform sm:w-auto sm:-rotate-12">{{
            'PAGE.ABOUT.HISTORY.ARROW' | translate
          }}</span>
          <svg
            class="relative w-24 h-auto transform rotate-90 -translate-y-5 -left-4 -scale-y-100 text-slate-600 sm:-left-8 sm:w-32 sm:translate-y-2 sm:-rotate-6 sm:scale-100"
            fill="none"
            height="121"
            viewBox="0 0 124 121"
            width="124"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_257_335)">
              <path
                d="M101.672 26.3321C96.8237 38.134 92.186 44.0573 79.0339 44.4141C70.6979 44.6403 60.8529 42.694 53.4527 38.7688C49.1632 36.4936 56.8633 35.9887 58.3238 36.046C75.2213 36.7084 91.469 47.7751 94.8076 64.9225C96.9834 76.0979 88.4245 81.9067 78.6041 84.1752C63.6278 87.6349 47.752 81.2525 36.0397 72.0991C32.1436 69.0541 19.8172 60.5149 22.0934 54.2698C23.9793 49.0954 31.7507 55.0061 34.018 56.9118C37.2506 59.6288 44.0244 65.7437 43.9149 70.3449C43.7576 76.9438 32.7995 78.0771 28.2217 77.7848C19.5283 77.2298 10.3327 73.6012 2.05876 71.0225C1.4496 70.8325 5.37871 69.9759 6.06477 69.8198C8.02976 69.3721 9.72632 68.1441 11.7325 67.8657C13.2208 67.6592 21.2769 68.287 16.2554 69.947C14.4855 70.532 2.71379 69.3189 2.58655 69.7453C2.06535 71.4868 10.2182 79.8642 11.7371 81.4008C15.3955 85.1003 14.5874 73.4626 14.2296 71.9325"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="2" />
            </g>
            <defs>
              <clipPath id="clip0_257_335">
                <rect
                  fill="white"
                  height="67"
                  transform="matrix(-0.748497 0.663138 0.663138 0.748497 79.3407 0)"
                  width="106" />
              </clipPath>
            </defs>
          </svg>
        </li>
      </ol>
    </div>
  </div>
</section>

<!-- Awards -->
<section class="py-16 overflow-hidden bg-slate-900 sm:py-24 lg:py-32">
  <!-- Container -->
  <div class="max-w-screen-xl px-5 mx-auto sm:px-6 lg:px-8">
    <!-- Section header -->
    <div class="text-center">
      <h2 class="text-4xl font-semibold text-white font-display sm:text-5xl">
        {{ 'PAGE.ABOUT.SUPPORTED.TITLE' | translate }}
      </h2>
      <p class="max-w-md mx-auto mt-6 text-lg leading-8 text-slate-50">
        {{ 'PAGE.ABOUT.SUPPORTED.INTRO' | translate }}
      </p>
    </div>
  </div>
</section>
